export enum UserRoleEnum {
  MANAGER = 'manager',
  CANDIDATE = 'candidate',
}
